module.exports = __webpack_public_path__ + "static/media/creditCardWarning.7573e398.svg";